import styled from "styled-components";
import React from "react";
import { TextField as MuiTextField } from "@mui/material";

export const Container = styled.div`
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  margin-top: 16px;
  display: flex; /* 플렉스 컨테이너로 변경 */
  flex-direction: column; /* 하위 요소들을 세로 방향으로 배치 */
  justify-content: center; /* 세로축 중앙 정렬 */
  width: 640px;
  font-weight: normal;
  border: 1px solid #ececec;
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.1);
  background-color: ${({ theme }) => theme.colors.WHITE};

  @media (max-width: 768px) {
    width: calc(100% - 1px);
  }
`;

export const TitleField = styled(MuiTextField)<{ alert: boolean }>`
  padding: 16px;
  div {
    font-weight: bold;
    font-size: 24px;
    background-color: ${({ theme }) => theme.colors.GREY_LIGHT};
    border: ${({ alert }) => (alert ? `1px solid red` : `none`)};

    ::before {
      border-bottom: ${({ theme }) => `1px solid ${theme.colors.GREY_HEAVY}`};
    }

    ::after {
      border-bottom: ${({ theme }) => `2px solid ${theme.colors.BLUE_HEAVY}`};
    }
  }

  input {
    padding: 0;
  }
`;
